import registerColorSwatch from '../../../common/colorSwatches/index';
import presentationalComponent from './ColorSwatch';
import containerComponent from './ColorSwatchContainer';

import { isApple } from '../../utils/services/browser';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerColorSwatch({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.CUSTOM_COLOR, TOOLS.COLOR_DISPLAY, TOOLS.CAPTION, TOOLS.REACTION],
        // TODO: Change tooltip for color swatch once determined
        tooltip: isApple ? '⌃⌘N' : 'Ctrl+Alt+N',
    });
